import axios, { AxiosError, isAxiosError } from 'axios';
import { AppDispatch, AppThunk } from '../../store';
import { login, logout ,setUser} from '../../Reducers/Organization/AuthReducer';
import ReduxResponse from '../../Modals/ReduxResponseModals/ReduxResponse';
import OrganizationAxiosInstance from '../../Services/OrganizationAxiosInstance';


export const loginOrganization = (email: string, password: string): AppThunk<Promise<ReduxResponse>> => async (dispatch: AppDispatch) => {
  try {
    const response = await axios.post(process.env.REACT_APP_HOST + 'OrganizationAuth/login', 
      { email, password }, 
      { headers: { 'Content-Type': 'application/json' } }
    );

    const actionResponse: ReduxResponse = {
      message: "Login Successful",
      payload: response.data.organization,
      success: true,
    };

    dispatch(login(response.data.organization));
    return actionResponse;

  } catch (error) {
    // Assert the error to be AxiosError
    if (isAxiosError(error)) {
      const errorMessage = error.response?.data?.error || "Something went wrong";
      const actionResponse: ReduxResponse = {
        message: `Error: ${errorMessage}`,
        payload: null,
        success: false,
      };
      return actionResponse;
    }

    // Fallback for non-Axios errors
    const actionResponse: ReduxResponse = {
      message: "Unexpected error occurred",
      payload: null,
      success: false,
    };
    return actionResponse;
  }
};

export const refetchOrganization = (): AppThunk<Promise<ReduxResponse>> => async (dispatch: AppDispatch) => {
  try {
    const response = await OrganizationAxiosInstance.get('Organization');

    const actionResponse: ReduxResponse = {
      message: "Refetch Successfull",
      payload: response.data.organization,
      success: true,
    };

    dispatch(setUser(response.data.organization));
    return actionResponse;

  } catch (error) {
    // Assert the error to be AxiosError
    if (isAxiosError(error)) {
      const errorMessage = error.response?.data?.error || "Something went wrong";
      const actionResponse: ReduxResponse = {
        message: `Error: ${errorMessage}`,
        payload: null,
        success: false,
      };
      return actionResponse;
    }

    // Fallback for non-Axios errors
    const actionResponse: ReduxResponse = {
      message: "Unexpected error occurred",
      payload: null,
      success: false,
    };
    return actionResponse;
  }
};


export const logoutOrganization = (): AppThunk=>(dispatch:AppDispatch)=>{
  dispatch(logout())
}

export const loginWithSession = (session: string): AppThunk<void> => (dispatch: AppDispatch) => {
  try {
    const org = JSON.parse(atob(session));
    dispatch(login(org));
  } catch {
    // invalid session — do nothing
  }
};